module.exports = __webpack_public_path__ + "img/Anindya_Dutta.6dc83b58.png";